import { Container, Graphics, IDestroyOptions, Sprite } from "pixi.js";
import { GameModel } from "../../models/GameModel";
import { GameResourcesPackage } from "../../resources/GameResourcesPackage";
import { nameof } from "bindable-data";
import { AudioController, Sfx } from "../AudioController";

export class TimeLeftComponent extends Container {
    private substrate: Sprite;
    private progress: Sprite;
    private farm: Sprite;
    private tractor: Sprite;
    private progressMask: Graphics;
    
    private substrateWidth: number;
    private substrateHeight: number;

    private readonly initialTime: number;

    constructor(
        gameResources: GameResourcesPackage,
        private readonly gameModel: GameModel,
        private readonly audioController: AudioController,
    ) {
        super();
        this.substrate = new Sprite(gameResources.assets_game_ui_timer_bar_substrate_png);
        this.addChild(this.substrate);

        this.substrateWidth = this.substrate.width;
        this.substrateHeight = this.substrate.height;

        this.progress = new Sprite(gameResources.assets_game_ui_timer_bar_fill_png);
        this.addChild(this.progress);

        this.progressMask = new Graphics();
        this.addChild(this.progressMask);
        this.progress.mask = this.progressMask;

        this.farm = new Sprite(gameResources.assets_game_ui_timer_bar_house_png);
        this.farm.pivot.set(this.farm.width, this.farm.height);
        this.farm.position.set(this.substrate.width, -5);
        this.addChild(this.farm);

        this.tractor = new Sprite(gameResources.assets_game_ui_timer_bar_tractor_png);
        this.tractor.pivot.set(0, this.tractor.height);
        this.tractor.position.set(0, -5);
        this.addChild(this.tractor);

        this.initialTime = this.gameModel.totalLevelTimeMS;

        gameModel.propertyChanged.add(this.onGameModelPropertyChange, this);
    }

    private onGameModelPropertyChange(model: GameModel, key: string): void {
        if (key != nameof(model, "time")) {
            return;
        }

        if (model.time.value === 0) {
            this.audioController.playSfx(Sfx.TractorArrive);
        }
        
        const remaining = model.time.value;
        const ratio = 1 - Math.max(remaining / this.initialTime, 0);

        this.updateMaskAndTractor(ratio);
    }

    private updateMaskAndTractor(ratio: number): void {
        // Update mask rectangle
        this.progressMask.clear();
        this.progressMask.beginFill(0xffffff);
        this.progressMask.drawRect(0, 0, this.substrateWidth * ratio, this.substrateHeight);
        this.progressMask.endFill();

        // Move tractor
        this.tractor.pivot.set(ratio * this.tractor.width, this.tractor.height);
        this.tractor.x = this.substrateWidth * ratio;
    }

    public override destroy(options?: IDestroyOptions | boolean): void {
        this.gameModel.propertyChanged.remove(this.onGameModelPropertyChange, this);
        super.destroy(options);
    }

}